module.exports = {
    HA_VT_EG_MEDIA_GATEWAY_THROTTLE: 'HA_VT_EG_Media_Gateway_Throttle',
    VRBO_VT_DIRECT_NAV_ONLY: 'Vrbo_VT_Direct_Nav_Only',
};
